import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';
import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import { LocationLanguageContextType, StrapiWorkspaceDialog, WorkspaceDialogProps } from '../typings';
import { useStrapiWorkspaceDialog } from '../hooks/useStrapiWorkspaceDialog';
import { LocationLanguageContext } from '../contexts/LocationLanguageContext';
import { Languages } from '../utils/getAllSupportedLanguages';
import useWorkspaceDialogStyles from '../styles/WorkspaceDialog';

const WorkspaceDialog: React.FC<WorkspaceDialogProps> = ({ open, onDialogClose, workspaces, onWorkspaceChange }) => {
  const allStrapiWorkspaceDialog = useStrapiWorkspaceDialog();
  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language = locationLanguage ? locationLanguage.language : Languages.English;
  const workspaceDialogContent = allStrapiWorkspaceDialog.find((x: StrapiWorkspaceDialog) => x.locale === language);
  const classes = useWorkspaceDialogStyles();
  const [workspaceID, setWorkspaceID] = React.useState('');

  const handleWorkspaceChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newWorkspaceID = event.target.value as string;
    setWorkspaceID(newWorkspaceID);
    onWorkspaceChange(workspaces[newWorkspaceID]);
  };
  const handleClose = () => {
    onDialogClose();
  };

  const workspaceEntries = Object.entries(workspaces);
  if (workspaceEntries.length > 0 && workspaceDialogContent) {
    const { workspaceLabel, workspaceButton } = workspaceDialogContent;
    return (
      <Dialog maxWidth='xs' fullWidth onClose={handleClose} aria-labelledby='simple-dialog-title' open={open}>
        <div className={classes.dialogTitleContainer}>
          <IconButton aria-label='close' onClick={handleClose} className='close-icon-button'>
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.dialogContainer}>
          <div className={classes.dialogLogoContainer}>
            <StaticImage layout='constrained' placeholder='tracedSVG' src='../assets/LoginDialog/novade-logo.svg' alt='Novade logo' />
          </div>
          <div className={classes.dialogFormContainer}>
            <FormControl fullWidth variant='outlined' size='medium'>
              <InputLabel style={{ zIndex: 0 }} id='workspace-select-outlined-label'>
                {workspaceLabel}
              </InputLabel>
              <Select label={workspaceLabel} labelId='workspace-select-outlined-label' value={workspaceID} onChange={handleWorkspaceChange}>
                {workspaceEntries.map(([databaseID, workspace]) => (
                  <MenuItem value={databaseID} key={databaseID}>
                    {workspace.databaseName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Button
            disabled={!workspaceID}
            size='large'
            fullWidth
            variant='contained'
            color='secondary'
            style={{ textTransform: 'uppercase', color: 'white' }}
            onClick={() => onDialogClose(true)}
          >
            {workspaceButton}
          </Button>
        </DialogContent>
      </Dialog>
    );
  }

  return null;
};

export default WorkspaceDialog;
